var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndeterminateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 10,
    height: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3879_11673",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3879_11673)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 8.66667H11.3333V7.33333H4.66667V8.66667ZM3.33333 14C2.96667 14 2.65278 13.8694 2.39167 13.6083C2.13056 13.3472 2 13.0333 2 12.6667V3.33333C2 2.96667 2.13056 2.65278 2.39167 2.39167C2.65278 2.13056 2.96667 2 3.33333 2H12.6667C13.0333 2 13.3472 2.13056 13.6083 2.39167C13.8694 2.65278 14 2.96667 14 3.33333V12.6667C14 13.0333 13.8694 13.3472 13.6083 13.6083C13.3472 13.8694 13.0333 14 12.6667 14H3.33333Z",
    fill: "#0091FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndeterminateIcon);
export default __webpack_public_path__ + "static/media/IndeterminateIcon.dd0841107ed41eb976a3b6f2a204aca4.svg";
export { ForwardRef as ReactComponent };